import { graphql, HttpResponse } from 'msw';
import type { GetPerformanceChannelPostDetailQuery } from '@/__generated__/graphql';

export const getPerformanceChannelPostDetail = graphql.query<GetPerformanceChannelPostDetailQuery>(
  'GetPerformanceChannelPostDetail',
  ({ variables }) => {
    const { ulid } = variables;
    const now = new Date().toISOString();
    const isRegistered = true;

    return HttpResponse.json({
      data: {
        __typename: 'Query',
        performanceChannel: {
          __typename: 'PerformanceChannel',
          id: '0ebffe0d-ec5e-4f0c-86dd-01c7b8bccc54',
          content: {
            __typename: 'FanPost',
            ulid: ulid,
            channelID: '0ebffe0d-ec5e-4f0c-86dd-01c7b8bccc54',
            body: '返信元モック投稿',
            isMasked: false,
            isSpoiler: false,
            createdAt: now,
            updatedAt: now,
            fan: {
              __typename: 'Fan',
              id: 'fan-001',
              name: 'モックユーザー',
              iconImage: null,
            },
            reactions: {
              __typename: 'FanPostReactions',
              reactionCounts: [],
              myReactions: isRegistered ? [] : null,
              artistReactions: [],
            },
            superMessageInfo: null,
            parentContent: {
              __typename: 'ArtistPost',
              channelID: '0ebffe0d-ec5e-4f0c-86dd-01c7b8bccc54',
              ulid: 'ulid-29',
              body: '投稿詳細でた！',
              isSpoiler: false,
              isMasked: false,
              artistOfficial: {
                __typename: 'ArtistOfficial',
                id: 'artist-parent',
                iconImage: null,
              },
            },
          },
          permission: isRegistered
            ? { __typename: 'ChannelPermission' as const, actionable: true }
            : undefined,
          performance: {
            __typename: 'Performance',
            id: 'ccacb2c4-7a59-4e4e-8f73-e67c24ff9a17',
            slug: 'eventtest202509-4',
            displayName: 'eventtest202509-4',
          },
          artist: {
            __typename: 'Artist',
            id: '24aa1891-704e-424d-a838-9866298883e4',
            name: 'テスト用アーティスト',
          },
        },
      },
    });
  },
);
